import { render } from "./BuildingTypeEdit.vue?vue&type=template&id=267f0ad4"
import script from "./BuildingTypeEdit.vue?vue&type=script&lang=js"
export * from "./BuildingTypeEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__